import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAdminAuth } from "@/admin/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin");
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#062B2B] px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="mb-8 flex items-center justify-center">
          <img src="/cagrilogo.png" alt="ÇağrıNET" className="h-9 w-auto brightness-0 invert" />
        </div>

        <div className="rounded-2xl border border-zinc-800 bg-zinc-900/70 p-8 backdrop-blur-xl">
          <div className="flex items-center gap-3">
            <Lock className="h-5 w-5 text-[#5EEAD4]" />
            <h1 className="font-heading text-xl font-bold text-white">Yönetici Girişi</h1>
          </div>

          <form onSubmit={handleSubmit} className="mt-7 space-y-5">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-zinc-400">E-posta</label>
              <input
                data-testid="admin-login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-11 w-full rounded-lg border border-zinc-700 bg-zinc-950 px-4 text-sm text-white focus:border-[#0D9488] focus:outline-none"
              />
            </div>
            <div>
              <label className="mb-1.5 block text-sm font-medium text-zinc-400">Şifre</label>
              <input
                data-testid="admin-login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-11 w-full rounded-lg border border-zinc-700 bg-zinc-950 px-4 text-sm text-white focus:border-[#0D9488] focus:outline-none"
              />
            </div>
            {error && (
              <p data-testid="admin-login-error" className="rounded-lg bg-red-500/10 px-4 py-2.5 text-sm text-red-400">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="h-11 w-full rounded-lg bg-[#0D9488] text-sm font-bold text-white transition-colors duration-200 hover:bg-[#0F766E] disabled:opacity-60"
            >
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
